// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(fareType) {
  switch (fareType) {
    case "actual" :
        return /* Actual */2;
    case "current" :
        return /* Current */3;
    case "fixed" :
        return /* Fixed */0;
    case "new_fixed" :
        return /* NewFixed */1;
    default:
      return ErrorUtils$Catalyst.raiseError("FareType", "Invalid order fare type", fareType);
  }
}

function toString(fareType) {
  switch (fareType) {
    case /* Fixed */0 :
        return "fixed";
    case /* NewFixed */1 :
        return "new_fixed";
    case /* Actual */2 :
        return "actual";
    case /* Current */3 :
        return "current";
    
  }
}

export {
  fromString ,
  toString ,
  
}
/* No side effect */
